import { mapGetters } from 'vuex';
import SchoolLogoUpload from '../widgets/SchoolLogoUpload';
export default {
  name: 'SchoolLogo',
  data() {
    return {
      upload: false
    };
  },
  methods: {
    onUpdateLogo() {
      this.upload = true;
    },
    onUploadSuccess({
      result
    }) {
      if (result) {
        this.$store.commit('profile/setProfileLogo', result.url);
      }

      // window.location.reload();
    },

    onUploadFailure() {}
  },
  computed: {
    ...mapGetters('profile', ['profile', 'project'])
  },
  components: {
    SchoolLogoUpload
  }
};